/** Hosted payment page (/pay/<token>): what the player sees. Plain words, players are not developers. */
export const checkout = {
  pageTitle: "Pay {brand}",
  payTo: "Pay to",
  amount: "Amount",
  orderId: "Order",
  chooseNetwork: "Choose a network",
  chooseNetworkHint: "Pick the network you will send from. Your wallet or exchange must use the same one.",
  minimum: "Minimum {amount} {token}",
  recommended: "Lowest fees",
  sendTitle: "Send {token} on {network}",
  sendAmount: "Send <b>{amount} {token}</b> to this address",
  sendAny: "Send at least <b>{min} {token}</b> to this address",
  addressLabel: "Deposit address",
  qrAlt: "QR code of the deposit address",
  copyAddress: "Copy address",
  warnNetwork: "Only send {token} on {network}. Any other coin or network will be lost.",
  warnMinimum: "Less than {min} {token} is not credited automatically.",
  warnAddress: "This address is yours: you can use it again next time.",
  changeNetwork: "Change network",
  waiting: "Waiting for your payment…",
  waitingHint: "This page updates by itself. Keep it open until your payment shows up.",
  detected: "Payment received, confirming…",
  detectedHint: "Usually under a minute; Ethereum takes a few minutes.",
  completed: "Payment complete",
  completedBody: "{amount} {token} has been credited to your {brand} account.",
  belowMin: "{amount} {token} is below the minimum and was not credited automatically. Please contact {brand} support.",
  flagged: "This payment is being checked. Please contact {brand} support.",
  backTo: "Back to {brand}",
  redirecting: "Taking you back in {n} s…",
  expiredTitle: "This payment link has expired",
  expiredBody: "Go back to {brand} and start the deposit again.",
  invalidTitle: "Payment link not found",
  invalidBody: "Check the link, or go back to the site and start the deposit again.",
  viewTx: "View transaction",
  steps: ["Network", "Send", "Confirmed"],
  expiresIn: "Link valid {time}",
  validUntil: "Link valid until {time}",
  secured: "Secured by iCryptoNow",
  loadError: "Could not load this page. Check your connection and try again.",
  retry: "Try again",
};
